import React from 'react';
import { Check } from 'lucide-react';
import { WaitlistCTA } from './WaitlistCTA';
function FeatureItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-center gap-4 text-white/90" data-id="element-3851" data-mp="2xktjwriiq4af">
      <div className="shrink-0 rounded-full p-1 bg-white/10 text-white border border-white/20" data-id="element-3852" data-mp="32d34ds0v6c5b">
        <Check size={16} strokeWidth={3} data-id="element-3853" data-mp="37cpie3oinwf6" />
      </div>
      <span className="font-medium text-lg" data-id="element-3854" data-mp="37ek61pr6a2my">{text}</span>
    </li>;
}
export function PricingClosingCTA() {
  return <section className="py-20 md:py-32 bg-[#FAF8F4]" data-id="element-3855" data-mp="2ensamuhxli0o">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-3856" data-mp="2eojwhdlq81dr">
        <div className="bg-[#2B211A] rounded-[2.5rem] p-8 md:p-16 relative overflow-hidden shadow-2xl" data-id="element-3857" data-mp="2jmbyj0g353vo">
          {/* Subtle dark grid texture */}
          <div className="dark-grid opacity-30 absolute inset-0 pointer-events-none" aria-hidden="true" data-id="element-3858" data-mp="2onj36qmxlmy4" />
          

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-3859" data-mp="3v44qkd2z57yc">
            <div data-id="element-3860" data-mp="3xk313c4oi62">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-title font-bold text-white tracking-tight leading-[1.1] mb-6" data-id="element-3861" data-mp="1qhmm8cmwru8">
                Start free. Pay only
                <br data-id="element-3862" data-mp="3tsfu4n1zvoe7" />
                when you're ready.
              </h2>
              <p className="text-white/80 text-lg md:text-xl mb-10 max-w-lg leading-relaxed" data-id="element-3863" data-mp="3ou622lbkh3wt">
                Every feature. Every integration. $100 in credits on the house.
                No credit card, no sales call, no catch. When you need more, it
                starts $50/month.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-3864" data-mp="3a504f1sdnlr1">
                <WaitlistCTA analyticsLabel="pricing-closing" className="bg-white hover:bg-neutral-100 text-[#2B211A] px-8 py-4 rounded-xl font-bold text-lg transition-colors text-center" data-id="element-3865" data-mp="3646b1sw61eqr">
                  
                  Get Started For Free
                </WaitlistCTA>
                <button onClick={() => window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })} className="bg-transparent border border-white/20 hover:bg-white/10 text-white px-8 py-4 rounded-xl font-bold text-lg transition-colors text-center" data-id="element-3866" data-mp="2r7ywp97fv7je">
                  
                  See all plans
                </button>
              </div>

              {/* Glass card */}
              <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 max-w-sm" data-id="element-3867" data-mp="2ck88w175ubdc">
                <div className="flex items-center gap-3 mb-4" data-id="element-3868" data-mp="30bm1m89848yu">
                  <div className="w-10 h-10 rounded-xl bg-[#EA580C] flex items-center justify-center text-white font-bold text-xl shadow-sm" data-id="element-3869" data-mp="359nufkwgbmni">
                    $
                  </div>
                  <h4 className="text-white font-bold text-xl" data-id="element-3870" data-mp="2rgg2tt8der5t">
                    Up to $100 in credits
                  </h4>
                </div>
                <p className="text-white/70 text-sm font-medium leading-relaxed" data-id="element-3871" data-mp="3j8dsb2r3hqcx">
                  Every feature, every integration. When you need more, it
                  starts $50/month.
                </p>
              </div>
            </div>

            <div className="lg:pl-12" data-id="element-3872" data-mp="1citoot35nce4">
              <ul className="space-y-6" data-id="element-3873" data-mp="17mv4lhov0gji">
                <FeatureItem text="Slack-native — works in threads & @mentions" data-id="element-3874" data-mp="17k0lbthl11ro" />
                <FeatureItem text="Connects to the tools you already use" data-id="element-3875" data-mp="1mag83cpnchry" />
                <FeatureItem text="Runs real tasks, not just answers" data-id="element-3876" data-mp="1hcxw1dgc1mfq" />
                <FeatureItem text="Scheduled tasks & proactive check-ins" data-id="element-3877" data-mp="tm284rezzbdr" />
                <FeatureItem text="Reports, recaps & ready-to-send drafts" data-id="element-3878" data-mp="to58o5ds0mwq" />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}